import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import Card from "../../../components/UI/card/Card";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { createNewProduct } from "../../../services/product.service"; // Assuming this function exists
import { GROOVY_GROUP_PRODUCTS } from "../../../constants"; // Importing the constant for product groups

// Validation schema for Product Form
const validationSchema = Yup.object({
  name: Yup.string().required("Product name is required"),
  group: Yup.string().required("Product group is required"),
  volume: Yup.number().min(1, "Volume must be at least 1").required("Volume is required"),
  price: Yup.number().min(0, "Price must be at least 0").required("Price is required"),
  image: Yup.mixed().required("Product image is required"),
  approved: Yup.boolean(),
});

const ProductForm: React.FC<any> = (props) => {
  const { t } = useTranslation();
  const [displayImage, setDisplayImage] = useState<any>(null);
  const navigate = useNavigate();

  return (
    <div className="w-100">
      <div className="row justify-content-center">
        <div className="col-lg-12 col-md-12 col-sm-12 w-100">
          <Card>
            <div className="product__edit p-4 w-100">
              <h3 className="mb-2">Product</h3>

              {/* Image upload section */}
              <div className=" mb-2">
                <label htmlFor="image" className="upload-icon mb-2">
                  <Icon
                    icon="akar-icons:cloud-upload"
                    style={{ fontSize: "40px", color: "#007bff" }}
                  />
                </label>
                <div className="d-none">
                  <input
                    className="form-control-file"
                    type="file"
                    id="image"
                    name="image"
                    onChange={(ev: any) => setDisplayImage(ev.currentTarget.files[0])}
                    accept="image/png, image/jpeg"
                  />
                </div>
                <img
                  className="img-fluid rounded mt-3"
                  src={displayImage ? URL.createObjectURL(displayImage) : "/images/product.png"}
                  alt="product pic"
                  style={{ maxWidth: "200px" }}
                />
              </div>

              {/* Formik Form */}
              <Formik
                initialValues={{
                  name: props.product?.name || "",
                  group: props.product?.group || "",
                  volume: props.product?.volume || 0,
                  price: props.product?.price || 0,
                  image: props.product?.image || "",
                  approved: props.product?.approved || false,
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                  // Handle form submission
                  console.log(values);
                  const payload = {
                    ...values,
                    image: displayImage, // Assuming you're uploading the image and passing the file
                  };
                  const result = await createNewProduct(payload);
                  if (result) {
                    resetForm();
                    navigate("/products"); // Navigate to the product list page after submission
                  }
                }}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form>
                    {/* Product Group */}
                    <div className="form-group p-0 mb-3">
                      <Field
                        as="select"
                        id="group"
                        name="group"
                        className={`form-control ${errors.group && touched.group ? "is-invalid" : ""}`}
                      >
                        <option value={""} disabled>Select Product Group</option>
                        {GROOVY_GROUP_PRODUCTS.map((group, index) => (
                          <option key={index} value={group}>
                            {group}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="group" component="div" className="invalid-feedback" />
                    </div>

                    {/* Product Name */}
                    <div className="form-group p-0 mb-3">
                      <Field
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Product Name"
                        className={`form-control ${errors.name && touched.name ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage name="name" component="div" className="invalid-feedback" />
                    </div>

                    {/* Product Volume */}
                    <div className="form-group p-0 mb-3">
                      <Field
                        id="volume"
                        name="volume"
                        type="number"
                        placeholder="Product Volume"
                        className={`form-control ${errors.volume && touched.volume ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage name="volume" component="div" className="invalid-feedback" />
                    </div>

                    {/* Product Price */}
                    <div className="form-group p-0 mb-3">
                      <Field
                        id="price"
                        name="price"
                        type="number"
                        placeholder="Product Price"
                        className={`form-control ${errors.price && touched.price ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage name="price" component="div" className="invalid-feedback" />
                    </div>

                    {/* Approved */}
                    <div className="form-group d-flex gap-2 p-0 mb-3">
                      <Field
                        id="approved"
                        name="approved"
                        type="checkbox"
                        className={`form-check ${errors.approved && touched.approved ? "is-invalid" : ""}`}
                      />
                      <label htmlFor="approved">Approved</label>
                    </div>


                    {/* Submit and Cancel buttons */}
                    <div className="d-flex justify-content-between mt-4">
                      <button type="submit" className="btn btn-primary px-4">
                        Submit
                      </button>
                      <Link to="/products">
                        <button className="btn btn-secondary px-4">{t("cancel")}</button>
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ProductForm;
